/**
 * Mode HANYA BACA — peran PEMANTAU (K236 / BUSINESS-115, 1 Nov 2026).
 *
 * Penjaga SUNGGUHAN ada di server: `deps.require_profile` menolak SEMUA tulisan akun Pemantau (403
 * PEMANTAU_HANYA_MELIHAT). Berkas ini soal pengalaman pakai: tombol aksi tidak ditampilkan, supaya Pemantau
 * tidak menekan tombol yang pasti ditolak.
 *
 * Yang disembunyikan (di komponen `ui/button` dan `ui/switch`, satu tempat untuk ±600 tombol):
 *   - tombol berwarna utama (`variant` default) dan `destructive` — di layar staf hampir semuanya aksi
 *     (Simpan, Setujui, Konfirmasi, Buat, Hapus);
 *   - tombol `type="submit"`;
 *   - saklar (`Switch`) dikunci (tetap terlihat, tidak bisa diubah).
 * Tombol `outline`/`ghost`/`secondary`/`link` tetap tampil (tab, saring, buka, unduh, kembali); bila salah satunya
 * ternyata aksi, server menolaknya dengan kalimat "Akun Pemantau hanya bisa melihat…".
 * Tombol baca yang kebetulan berwarna utama ditandai `data-baca` supaya tetap tampil.
 */
import React from "react";

export const HanyaBacaContext = React.createContext(false);

export function useHanyaBaca() {
  return React.useContext(HanyaBacaContext);
}

/** MURNI — apakah tombol dengan properti ini tombol AKSI (disembunyikan saat hanya baca). */
export function tombolAksi(props) {
  const p = props || {};
  if (p["data-baca"]) return false;
  if (p.type === "submit") return true;
  return !p.variant || p.variant === "default" || p.variant === "destructive";
}
